module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "automation"
    }
  }, [_c('v-panel', {
    attrs: {
      "id": "automation"
    }
  }, [_c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "automation-filter-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "title text-uppercase"
  }, [_c('h3', [_c('span', [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" " + _vm._s(_vm.$t('automation.index.title')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'autoactions'),
      expression: "activeTab == 'autoactions'"
    }],
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "col-auto pull-right"
  }, [_c('div', {
    staticClass: "bookings"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-bold btn-red waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.new_autoaction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.new_autoaction')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportNotifications($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.export_autoactions')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openImportNotificationsModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.import_autoactions')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto pull-right"
  }, [_c('div', {
    staticClass: "calender_year action-select"
  }, [_c('form', [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedRental),
      expression: "selectedRental"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedRental = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.get_autoactions()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('automation.index.all')) + " ")]), _vm._v(" "), _vm._l((_vm.rentals), function(rental) {
    return _c('option', {
      domProps: {
        "value": rental.id
      }
    }, [_vm._v(_vm._s(rental.name))])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'shortcodes'),
      expression: "activeTab == 'shortcodes'"
    }],
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "col-auto pull-right"
  }, [_c('div', {
    staticClass: "bookings"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-bold btn-red waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.new_custom_short_code()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.new_custom_short_code')) + " ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.activeTab == 'autoactions' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('autoactions')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.title')))]), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'shortcodes' ? 'active' : '',
    attrs: {
      "id": "shortcodes-tab"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('shortcodes')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.custom_short_codes.title')))])])]), _vm._v(" "), _c('div', [(!_vm.loading && _vm.activeTab == 'autoactions') ? _c('div', [_c('div', {
    staticClass: "automation-table"
  }, [_c('div', {
    staticClass: "automation-list-group"
  }, _vm._l((_vm.occurs), function(occur, key) {
    return _c('div', [_c('div', {
      staticClass: "list-group-item list-title"
    }, [(key == 0) ? _c('div', {
      staticClass: "list-title-item"
    }, [_c('div', {
      staticClass: "list-title-item-div"
    }, [_c('div', {
      staticClass: "square"
    }), _vm._v(" "), _c('div', {
      staticClass: "stick"
    })])]) : _c('div', {
      staticClass: "list-mid-title-item"
    }, [_c('div', {
      staticClass: "list-title-item-div"
    }, [_c('div', {
      staticClass: "stick-top"
    }), _vm._v(" "), _c('div', {
      staticClass: "square"
    }), _vm._v(" "), _c('div', {
      staticClass: "stick"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "list-title-text"
    }, [_vm._v("\n\n                        " + _vm._s(_vm.$t('automation.index.' + occur.name)) + "\n                      ")])]), _vm._v(" "), (occur.autoactions.length == 0) ? _c('div', {
      staticClass: "list-group-item list-child"
    }, [_c('div', {
      staticClass: "list-child-text"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('automation.index.no_autoaction')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((occur.autoactions), function(autoaction, autoactionKey) {
      return _c('div', {
        staticClass: "list-group-item list-child"
      }, [_c('div', {
        staticClass: "list-child-item"
      }, [_c('div', {
        staticClass: "list-child-item-div"
      }, [_c('div', {
        staticClass: "stick"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list-child-text row"
      }, [_c('div', {
        staticClass: "auto auto-trigger-time col-4 d-flex align-items-center"
      }, [_c('div', [_c('div', {
        staticClass: "m-b-10 product-price action-title ",
        attrs: {
          "id": "auto-action-title"
        }
      }, [_vm._v(_vm._s(autoaction.title))]), _vm._v(" "), (!autoaction.airbnb_auto_action_id) ? _c('p', {
        staticClass: "m-b-0 trigger-time"
      }, [_vm._v(" " + _vm._s(autoaction.trigger_time == 0 || _vm.immediateTiggerTimes.includes(autoaction.trigger_time) ?
        _vm.$t('trigger_times[0]') : _vm.getTriggerTimeName(autoaction.trigger_time,
          autoaction.occur.name)))]) : _vm._e(), _vm._v(" "), (autoaction.airbnb_auto_action_id) ? _c('p', {
        staticClass: "m-b-0 trigger-time"
      }, [_vm._v(" " + _vm._s(autoaction.airbnb_action_days == 0 || autoaction.airbnb_action_days == 1 ||
        autoaction.airbnb_action_days == 'Immediate' || autoaction.airbnb_action_days ==
        'Immédiat' ? _vm.$t('trigger_times[0]') : _vm.getTriggerTimeName(autoaction.airbnb_action_days,
          autoaction.occur.name, true)))]) : _vm._e()])]), _vm._v(" "), _c('p', {
        staticClass: "auto auto-rental col-3 d-flex align-items-center"
      }, [_vm._v(_vm._s(_vm.getAutoactionRentalName(autoaction)))]), _vm._v(" "), _c('div', {
        staticClass: "auto auto-channel col-2 d-flex align-items-center"
      }, [_vm._v(_vm._s(_vm.getAutoactionChannelName(autoaction)))]), _vm._v(" "), _c('div', {
        staticClass: "col-3 d-flex align-items-center justify-content-end"
      }, [_c('div', [_c('div', {
        staticClass: "auto channel-change pull-right m-t-10"
      }, [_c('div', {
        staticClass: "btn-group"
      }, [_c('div', {
        staticClass: "dropdown"
      }, [_c('button', {
        staticClass: "btn btn-primary dropdown-toggle",
        attrs: {
          "type": "button",
          "data-toggle": "dropdown"
        }
      }, [_c('i', {
        staticClass: "bulle"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-menu dropdown-menu-right",
        class: key + 1 === _vm.occurs.length && autoactionKey + 1 === occur.autoactions.length ? 'dropdown-top' : ''
      }, [_c('a', {
        staticClass: "dropdown-item waves-effect waves-light waves-round",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            autoaction.airbnb_auto_action_id ? _vm.$refs.airbnbAutoaction.edit_autoaction_for_airbnb(autoaction) : _vm.edit_autoaction(autoaction)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
        staticClass: "dropdown-item waves-effect waves-light waves-round",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.duplicate_autoaction(autoaction.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("button.duplicate")))]), _vm._v(" "), (![6, 7, 8].includes(autoaction.action_occur_id)) ? _c('a', {
        staticClass: "dropdown-item waves-effect waves-light waves-round",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.open_test_notification_modal(autoaction.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("button.test")))]) : _vm._e(), _vm._v(" "), _c('a', {
        staticClass: "dropdown-item waves-effect waves-light waves-round",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.delete_autoaction(autoaction.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("button.delete")))])])])])]), _vm._v(" "), _c('div', {
        staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
        on: {
          "click": function($event) {
            _vm.changeStatus(autoaction.id, autoaction.status)
          }
        }
      }, [_c('switches', {
        attrs: {
          "theme": "bulma",
          "color": "blue",
          "type-bold": "false"
        },
        model: {
          value: (autoaction.status),
          callback: function($$v) {
            _vm.$set(autoaction, "status", $$v)
          },
          expression: "autoaction.status"
        }
      })], 1)])])])])
    })], 2)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "automation-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editAutoaction ? _vm.update_autoaction() : _vm.save_autoaction()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.editAutoaction ? _vm.$t('automation.index.modal.modal_title_edit') :
    _vm.$t('automation.index.modal.modal_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeAutomationModal()
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.title")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Title",
      "data-content": _vm.$t('automation.index.modal.title_pop_up')
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.title),
      expression: "newAutoAction.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.newAutoAction.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAutoAction, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_rental")))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "This Rental",
      "data-content": _vm.$t('automation.index.modal.rental_pop_up')
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-lg dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('automation.index.select_rentals')) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu auto-overflow",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, [_c('div', {
    staticClass: "checkbox-custom m-l-10 checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allRentals),
      expression: "allRentals"
    }],
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.allRentals) ? _vm._i(_vm.allRentals, null) > -1 : (_vm.allRentals)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allRentals,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allRentals = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allRentals = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allRentals = $$c
        }
      }, function($event) {
        _vm.filterByRentals('all')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.all')))])]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return (group.rentals.length > 0) ? _c('ul', {
      staticClass: "checkbox-custom m-l-30 checkbox-primary",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedGroups[group.id]),
        expression: "checkedGroups[group.id]"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("auto-action-group-" + (group.id))
      },
      domProps: {
        "checked": Array.isArray(_vm.checkedGroups[group.id]) ? _vm._i(_vm.checkedGroups[group.id], null) > -1 : (_vm.checkedGroups[group.id])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedGroups[group.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checkedGroups, group.id, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checkedGroups, group.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checkedGroups, group.id, $$c)
          }
        }, function($event) {
          _vm.filterByRentals(group.id)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("auto-action-group-" + (group.id))
      }
    }, [_c('span', {
      staticClass: "long-rental-name"
    }, [_vm._v("\n                                      " + _vm._s(group.name === 'others' ? _vm.$t('groups.others') : group.name) + "\n                                    ")])]), _vm._v(" "), _vm._l((group.rentals), function(rental) {
      return _c('li', {
        staticClass: "checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.checkedRentals[rental.id]),
          expression: "checkedRentals[rental.id]"
        }],
        attrs: {
          "type": "checkbox",
          "id": ("auto-action-rental-" + (rental.id))
        },
        domProps: {
          "checked": Array.isArray(_vm.checkedRentals[rental.id]) ? _vm._i(_vm.checkedRentals[rental.id], null) > -1 : (_vm.checkedRentals[rental.id])
        },
        on: {
          "change": [function($event) {
            var $$a = _vm.checkedRentals[rental.id],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.checkedRentals, rental.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.checkedRentals, rental.id, $$c)
            }
          }, function($event) {
            _vm.filterByRentals()
          }]
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": ("auto-action-rental-" + (rental.id))
        }
      }, [_c('span', {
        staticClass: "long-rental-name"
      }, [_vm._v("\n                                        " + _vm._s(rental.name) + "\n                                      ")])])])
    })], 2) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.event_occur")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Event Occur",
      "data-content": _vm.$t('automation.index.modal.event_pop_up')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.action_occur_id),
      expression: "newAutoAction.action_occur_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "action_occur_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        $event.preventDefault();
        _vm.changeAutoaction()
      }]
    }
  }, _vm._l((_vm.action_occurs), function(action_occur) {
    return _c('option', {
      domProps: {
        "value": action_occur.id
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('automation.index.' + action_occur.name)) + " ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_action")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Action Type",
      "data-content": _vm.$t('automation.index.modal.perform_action_pop_up')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.action_type),
      expression: "newAutoAction.action_type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "action_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.findTypeOfSms()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.actionType.email
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.send_email")))]), _vm._v(" "), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.smsIntegration),
      expression: "smsIntegration"
    }],
    domProps: {
      "value": _vm.actionType.sms
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.send_sms")))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.actionType.notification
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.send_push_notification")))]), _vm._v(" "), (_vm.selectedActionOccur.name == 'after-checkout') ? _c('option', {
    domProps: {
      "value": _vm.actionType.sendReview
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.send_airbnb_review")))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(((_vm.selectedActionOccur.name !== 'temperature' && _vm.selectedActionOccur.name !== 'co2' && _vm.selectedActionOccur.name !== 'noise-sound') || _vm.newAutoAction.action_occur_id === 1) && _vm.selectedActionOccur.name !== 'specific-day') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.trigger_time")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Action Time",
      "data-content": _vm.getTriggerTimeContent(_vm.newAutoAction.action_occur_id)
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.trigger_time),
      expression: "newAutoAction.trigger_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "trigger_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._l((_vm.$t('trigger_times')), function(trigger_time, index) {
    return _c('option', {
      domProps: {
        "value": trigger_time
      }
    }, [_vm._v(_vm._s((index != 0 ? _vm.signBeforeDays : '') + trigger_time))])
  }), _vm._v(" "), _vm._l((365), function(trigger_time) {
    return _c('option', {
      domProps: {
        "value": (trigger_time + " " + ((trigger_time === 1 ? _vm.$t('day') : _vm.$t('days'))))
      }
    }, [_vm._v(_vm._s(trigger_time == 1 ? _vm.signBeforeDays + trigger_time + " " + _vm.$t('day') : _vm.signBeforeDays + trigger_time + " " + _vm.$t('days')))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.newAutoAction.action_occur_id === 20) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.trigger_time")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Specific date",
      "data-content": _vm.$t('automation.index.modal.specific_time_pop_up')
    }
  })]), _vm._v(" "), _c('date-time-picker', {
    ref: "reminder-picker",
    staticClass: "form-control",
    attrs: {
      "type": "datetime",
      "lang": _vm.language,
      "not-before": new Date(),
      "clearable": true,
      "width": "100%",
      "id": "specific-day",
      "show-second": 'false',
      "format": "YYYY-MM-DD HH:mm:ss"
    },
    model: {
      value: (_vm.newAutoAction.trigger_time),
      callback: function($$v) {
        _vm.$set(_vm.newAutoAction, "trigger_time", $$v)
      },
      expression: "newAutoAction.trigger_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedActionOccur.name == 'temperature' && _vm.newAutoAction.action_occur_id == 6) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.temperature")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Temperature",
      "data-content": _vm.$t('automation.index.modal.specific_time_pop_up')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.trigger_time),
      expression: "newAutoAction.trigger_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "trigger_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((40), function(trigger_time) {
    return _c('option', {
      domProps: {
        "value": trigger_time
      }
    }, [_vm._v(_vm._s(trigger_time))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.selectedActionOccur.name == 'co2' && _vm.newAutoAction.action_occur_id == 7) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.co2")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Co 2",
      "data-content": _vm.$t('automation.index.modal.specific_time_pop_up')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.trigger_time),
      expression: "newAutoAction.trigger_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "trigger_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((100), function(trigger_time) {
    return _c('option', {
      domProps: {
        "value": trigger_time
      }
    }, [_vm._v(_vm._s(trigger_time) + " ")])
  }))])]) : _vm._e(), _vm._v(" "), (!_vm.isEnvironmentOccur) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channels.length > 0),
      expression: "channels.length > 0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_channel")))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Action Channel",
      "data-content": _vm.$t('automation.index.modal.channel_pop_up')
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.typeIsReview && _vm.newAutoAction.action_occur_id !== 25),
      expression: "!typeIsReview && newAutoAction.action_occur_id !== 25"
    }],
    staticClass: "btn btn-secondary btn-lg dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('automation.index.select_channels')) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu rentals-list auto-overflow",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, [_c('div', {
    staticClass: "checkbox-custom m-l-10 checkbox-primary mb-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areAllChannelsChecked),
      expression: "areAllChannelsChecked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.areAllChannelsChecked) ? _vm._i(_vm.areAllChannelsChecked, null) > -1 : (_vm.areAllChannelsChecked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.areAllChannelsChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.areAllChannelsChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.areAllChannelsChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.areAllChannelsChecked = $$c
        }
      }, function($event) {
        _vm.filterByChannels('all')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.modal.all_channels')))])]), _vm._v(" "), _c('ul', {
    staticClass: "checkbox-custom m-l-30 checkbox-primary m-10",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "channel-list"
    }
  }, _vm._l((_vm.channels), function(channel) {
    return _c('li', {
      staticClass: "checkbox-custom m-l-10 checkbox-inline checkbox-primary d-flex align-items-center m-10"
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (channel.is_checked),
        expression: "channel.is_checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": channel.name
      },
      domProps: {
        "checked": Array.isArray(channel.is_checked) ? _vm._i(channel.is_checked, null) > -1 : (channel.is_checked)
      },
      on: {
        "change": [function($event) {
          var $$a = channel.is_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(channel, "is_checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(channel, "is_checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(channel, "is_checked", $$c)
          }
        }, function($event) {
          _vm.filterByChannels(channel.id)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": channel.name
      }
    }, [_vm._v(_vm._s(channel.name))])])])
  }))]), _vm._v(" "), (_vm.typeIsReview || _vm.newAutoAction.action_occur_id === 25) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.channel_id),
      expression: "newAutoAction.channel_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.typeIsReview || _vm.newAutoAction.action_occur_id === 25
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "channel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.all_platform')))]), _vm._v(" "), _vm._l((_vm.channels), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.id
      }
    }, [_vm._v(_vm._s(channel.name))])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isEnvironmentOccur) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('input.status')))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Booking status",
      "data-content": _vm.$t('automation.index.modal.STATUS')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.paid_status),
      expression: "newAutoAction.paid_status"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.newAutoAction.action_occur_id === 25
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAutoAction, "paid_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('input.none')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "if_booking_is_paid"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.if_booking_is_paid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "if_booking_not_paid"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.if_booking_not_paid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "if_deposit_is_paid"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.if_deposit_is_paid')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "if_deposit_not_paid"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.if_deposit_not_paid')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedActionOccur.name != 'co2' && _vm.selectedActionOccur.name != 'temperature' && _vm.newAutoAction.also_to_guest && !_vm.typeIsEmail && _vm.newAutoAction.action_type !== 'notification' && !_vm.typeIsReview),
      expression: "selectedActionOccur.name != 'co2' && selectedActionOccur.name != 'temperature' && newAutoAction.also_to_guest && !typeIsEmail && newAutoAction.action_type !== 'notification' && !typeIsReview"
    }],
    staticClass: "col-sm-6 toGuest-div"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Send to guest",
      "data-content": _vm.$t('automation.index.modal.guest_pop_up')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.also_to_guest),
      expression: "newAutoAction.also_to_guest"
    }],
    attrs: {
      "type": "checkbox",
      "id": "assignToGuest",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.newAutoAction.also_to_guest) ? _vm._i(_vm.newAutoAction.also_to_guest, null) > -1 : (_vm.newAutoAction.also_to_guest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newAutoAction.also_to_guest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newAutoAction, "also_to_guest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newAutoAction, "also_to_guest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newAutoAction, "also_to_guest", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "assignToGuest"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.modal.to_guest')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.typeIsEmail && !_vm.typeIsReview) || (_vm.newAutoAction.action_type == 'notification' && _vm.selectedActionOccur.name != 'noise-sound')),
      expression: "(typeIsEmail && !typeIsReview) || (newAutoAction.action_type == 'notification' && selectedActionOccur.name != 'noise-sound')"
    }],
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_recipient")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Recipient",
      "data-content": _vm.$t('automation.index.modal.recipient_pop_up')
    }
  })]), _vm._v(" "), _c('input-tag', {
    staticClass: "form-control",
    attrs: {
      "required": "",
      "add-tag-on-blur": true,
      "allow-duplicates": true,
      "add-tag-on-keys": [32]
    },
    model: {
      value: (_vm.newAutoAction.recipients),
      callback: function($$v) {
        _vm.$set(_vm.newAutoAction, "recipients", $$v)
      },
      expression: "newAutoAction.recipients"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.typeIsEmail && _vm.newAutoAction.action_type == 'sms' && !_vm.newAutoAction.also_to_guest),
      expression: "!typeIsEmail && newAutoAction.action_type == 'sms' && !newAutoAction.also_to_guest"
    }],
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.phone_number")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Phone number",
      "data-content": _vm.$t('automation.index.modal.phone_pop_up')
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.phone_number),
      expression: "newAutoAction.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAutoAction.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAutoAction, "phone_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneError),
      expression: "phoneError"
    }],
    staticStyle: {
      "color": "#D7092E",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.phoneError))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row assign-section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.selectedActionOccur.name != 'co2' && _vm.selectedActionOccur.name != 'temperature' && ((!_vm.newAutoAction.also_to_guest && !_vm.typeIsEmail) || (_vm.typeIsEmail || _vm.newAutoAction.action_type === 'notification')) || _vm.newAutoAction.action_occur_id == 1 && _vm.newAutoAction.action_type !== 'sms') && !_vm.typeIsReview),
      expression: "(selectedActionOccur.name != 'co2' && selectedActionOccur.name != 'temperature' && ((!newAutoAction.also_to_guest && !typeIsEmail) || (typeIsEmail || newAutoAction.action_type === 'notification')) || newAutoAction.action_occur_id == 1 && newAutoAction.action_type !== 'sms')  && !typeIsReview"
    }],
    staticClass: "toGuest col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('automation.index.modal.guest_pop_up_title'),
      "data-content": _vm.$t('automation.index.modal.guest_pop_up')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.also_to_guest),
      expression: "newAutoAction.also_to_guest"
    }],
    attrs: {
      "type": "checkbox",
      "id": "toGuest",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.newAutoAction.also_to_guest) ? _vm._i(_vm.newAutoAction.also_to_guest, null) > -1 : (_vm.newAutoAction.also_to_guest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newAutoAction.also_to_guest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newAutoAction, "also_to_guest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newAutoAction, "also_to_guest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newAutoAction, "also_to_guest", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "toGuest"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.modal.to_guest')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (![6, 7, 8].includes(_vm.newAutoAction.action_occur_id)),
      expression: "![6,7,8].includes(newAutoAction.action_occur_id)"
    }],
    class: ("toGuest-div " + (_vm.typeIsReview ? 'col-sm-6' : 'col-sm-4'))
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary float-left d-flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.also_to_assigned_member),
      expression: "newAutoAction.also_to_assigned_member"
    }],
    attrs: {
      "type": "checkbox",
      "id": "member",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.newAutoAction.also_to_assigned_member) ? _vm._i(_vm.newAutoAction.also_to_assigned_member, null) > -1 : (_vm.newAutoAction.also_to_assigned_member)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newAutoAction.also_to_assigned_member,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newAutoAction, "also_to_assigned_member", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newAutoAction, "also_to_assigned_member", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newAutoAction, "also_to_assigned_member", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "member"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('automation.index.modal.to_assigned_member')))])])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('automation.index.modal.member_pop_up_title'),
      "data-content": _vm.$t('automation.index.modal.member_pop_up')
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customColorIsShown),
      expression: "customColorIsShown"
    }],
    class: ("toGuest-div " + (_vm.typeIsReview ? 'col-sm-6' : 'col-sm-4'))
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "customize-color"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.enable_custom_color),
      expression: "newAutoAction.enable_custom_color"
    }],
    attrs: {
      "type": "checkbox",
      "id": "enable-custom-color"
    },
    domProps: {
      "checked": Array.isArray(_vm.newAutoAction.enable_custom_color) ? _vm._i(_vm.newAutoAction.enable_custom_color, null) > -1 : (_vm.newAutoAction.enable_custom_color)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newAutoAction.enable_custom_color,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newAutoAction, "enable_custom_color", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newAutoAction, "enable_custom_color", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newAutoAction, "enable_custom_color", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enable-custom-color"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.modal.custom_color')))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-25"
  }, [_c('color-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAutoAction.enable_custom_color),
      expression: "newAutoAction.enable_custom_color"
    }],
    staticClass: "mb-0",
    attrs: {
      "color": _vm.newAutoAction.color,
      "name": false,
      "enableColor": _vm.newAutoAction.enable_custom_color
    },
    on: {
      "updateCurrentColor": _vm.updateCurrentColor
    },
    model: {
      value: (_vm.newAutoAction.color),
      callback: function($$v) {
        _vm.$set(_vm.newAutoAction, "color", $$v)
      },
      expression: "newAutoAction.color"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_lang),
      expression: "newAutoAction.message_lang"
    }],
    attrs: {
      "type": "radio",
      "id": "content-fr",
      "name": "content-lang",
      "value": "fr"
    },
    domProps: {
      "checked": _vm._q(_vm.newAutoAction.message_lang, "fr")
    },
    on: {
      "change": [function($event) {
        _vm.$set(_vm.newAutoAction, "message_lang", "fr")
      }, function($event) {
        _vm.notificationContentLangChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "content-fr"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.french")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_lang),
      expression: "newAutoAction.message_lang"
    }],
    attrs: {
      "type": "radio",
      "id": "content-en",
      "name": "content-lang",
      "value": "en"
    },
    domProps: {
      "checked": _vm._q(_vm.newAutoAction.message_lang, "en")
    },
    on: {
      "change": [function($event) {
        _vm.$set(_vm.newAutoAction, "message_lang", "en")
      }, function($event) {
        _vm.notificationContentLangChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "content-en"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.english")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_lang),
      expression: "newAutoAction.message_lang"
    }],
    attrs: {
      "type": "radio",
      "id": "content-pt",
      "name": "content-lang",
      "value": "pt"
    },
    domProps: {
      "checked": _vm._q(_vm.newAutoAction.message_lang, "pt")
    },
    on: {
      "change": [function($event) {
        _vm.$set(_vm.newAutoAction, "message_lang", "pt")
      }, function($event) {
        _vm.notificationContentLangChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "content-pt"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.portugal")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_lang),
      expression: "newAutoAction.message_lang"
    }],
    attrs: {
      "type": "radio",
      "id": "content-es",
      "name": "content-lang",
      "value": "es"
    },
    domProps: {
      "checked": _vm._q(_vm.newAutoAction.message_lang, "es")
    },
    on: {
      "change": [function($event) {
        _vm.$set(_vm.newAutoAction, "message_lang", "es")
      }, function($event) {
        _vm.notificationContentLangChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "content-es"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.spanish")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_lang),
      expression: "newAutoAction.message_lang"
    }],
    attrs: {
      "type": "radio",
      "id": "content-it",
      "name": "content-lang",
      "value": "it"
    },
    domProps: {
      "checked": _vm._q(_vm.newAutoAction.message_lang, "it")
    },
    on: {
      "change": [function($event) {
        _vm.$set(_vm.newAutoAction, "message_lang", "it")
      }, function($event) {
        _vm.notificationContentLangChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "content-it"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.italian")))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newAutoAction.action_type == _vm.actionType.email),
      expression: "newAutoAction.action_type == actionType.email"
    }],
    staticClass: "email-subject"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('input.subject')))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Subject",
      "data-content": _vm.$t('automation.index.modal.subject_pop_up')
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.email_subject),
      expression: "newAutoAction.email_subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "auto-action-email-subject"
    },
    domProps: {
      "value": (_vm.newAutoAction.email_subject)
    },
    on: {
      "change": function($event) {
        _vm.emailSubjectChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAutoAction, "email_subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (![6, 7].includes(_vm.newAutoAction.action_occur_id)) ? _c('button', {
    staticClass: "btn ",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openShortcodeListModal('#shortcode-list-modal', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))]) : _vm._e()]), _vm._v(" "), (_vm.typeIsEmail || _vm.typeIsReview) ? _c('div', {
    staticClass: "panel-content-inner",
    on: {
      "click": function($event) {
        _vm.checkEmailTypeContent(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      },
      "input": function($event) {
        _vm.checkEmailTypeContent(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      }
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_message")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Message",
      "data-content": _vm.$t('automation.index.modal.message_pop_up')
    }
  })]), _vm._v(" "), (_vm.typeIsEmail || _vm.typeIsReview) ? _c('redactor', {
    attrs: {
      "contract": _vm.redactorContent,
      "rentalId": "",
      "action_occur_id": _vm.newAutoAction.action_occur_id,
      "shortCodes": _vm.shortCodes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.typeIsEmail && !_vm.typeIsReview),
      expression: "!typeIsEmail && !typeIsReview"
    }],
    staticClass: "col-sm-12",
    attrs: {
      "id": "auto-send-sms"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_message")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": "Sms",
      "data-content": _vm.$t('automation.index.modal.message_pop_up')
    }
  })]), _vm._v(" "), (![6, 7].includes(_vm.newAutoAction.action_occur_id)) ? _c('span', {
    staticClass: "m-lg-4 cursor-pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openShortcodeListModal('#shortcode-list-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))]) : _vm._e(), _vm._v(" "), (_vm.newAutoAction.action_type == 'sms') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_sms),
      expression: "newAutoAction.message_sms"
    }],
    staticClass: "form-control m-t-15",
    attrs: {
      "cols": "30",
      "rows": "8",
      "id": "auto-action-sms-content"
    },
    domProps: {
      "value": (_vm.newAutoAction.message_sms)
    },
    on: {
      "change": function($event) {
        _vm.notificationActionTypesContentChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAutoAction, "message_sms", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newAutoAction.action_type == 'notification') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAutoAction.message_notification),
      expression: "newAutoAction.message_notification"
    }],
    staticClass: "form-control m-t-15",
    attrs: {
      "cols": "30",
      "rows": "8",
      "id": "auto-action-notification-content"
    },
    domProps: {
      "value": (_vm.newAutoAction.message_notification)
    },
    on: {
      "change": function($event) {
        _vm.notificationActionTypesContentChange(_vm.newAutoAction.action_type, _vm.newAutoAction.message_lang)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAutoAction, "message_notification", $event.target.value)
      }
    }
  }) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.smallLoading) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "id": "modal-close",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeAutomationModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.smallLoading) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": !_vm.newAutoAction.also_to_guest && (_vm.phoneError || (_vm.newAutoAction.action_type === 'sms' && (_vm.newAutoAction.phone_number && _vm.newAutoAction.phone_number.length < 10)))
    }
  }, [_vm._v(_vm._s(_vm.editAutoaction ? _vm.$t("button.update") : _vm.$t("button.save")))]) : _vm._e(), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "test-notification-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send_test_notification()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.send_test_email")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close_test_notification_modal('#test-notification-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pl-0 pr-0 pb-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-title"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("input.booking_id")) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testNotificationData.booking_id),
      expression: "testNotificationData.booking_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "checklist-title",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.testNotificationData.booking_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testNotificationData, "booking_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-description"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("input.email")) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testNotificationData.email),
      expression: "testNotificationData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "checklist-description",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.testNotificationData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testNotificationData, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.smallLoading) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close_test_notification_modal('#test-notification-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.smallLoading) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send_test_notification")))]) : _vm._e(), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1)])])])]), _vm._v(" "), _c('VShortCodeListModal', {
    attrs: {
      "selectedShortCode": _vm.selectedShortCode,
      "actionOccurId": _vm.newAutoAction.action_occur_id,
      "shortCodeName": _vm.shortCodeName
    },
    on: {
      "insertShortcodeToText": _vm.insertShortcodeToText,
      "closeAndOpenModals": _vm.closeAndOpenModals,
      "changeSelectedShortCode": _vm.changeSelectedShortCode
    }
  }), _vm._v(" "), _c('v-autoaction-help-modal', {
    ref: "autoactionHelpModal"
  })], 1) : _vm._e()])])]), _vm._v(" "), (!_vm.loading && _vm.activeTab == 'shortcodes') ? _c('div', [_c('div', {
    staticClass: "automation-table"
  }, [_c('div', {
    staticClass: "automation-list-group"
  }, [(_vm.shortCodes.length == 0) ? _c('div', {
    staticClass: "list-group-item list-child"
  }, [_c('div', {
    staticClass: "list-child-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('automation.index.no_short_code')) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.shortCodes.length > 0) ? _c('div', {
    staticClass: "list-group-item list-title"
  }, [_c('div', {
    staticClass: "list-mid-title-item"
  }, [_c('div', {
    staticClass: "list-title-item-div"
  }, [_c('div', {
    staticClass: "square"
  }), _vm._v(" "), _c('div', {
    staticClass: "stick"
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shortCodes), function(shortCode) {
    return _c('div', [_c('div', {
      staticClass: "list-group-item list-child"
    }, [_c('div', {
      staticClass: "list-child-item"
    }, [_c('div', {
      staticClass: "list-child-item-div"
    }, [_c('div', {
      staticClass: "stick"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "list-child-text row"
    }, [_c('div', {
      staticClass: "auto auto-trigger-time col-3 d-flex align-items-center"
    }, [_c('div', [_c('div', {
      staticClass: "product-price action-title"
    }, [_vm._v(_vm._s(shortCode.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-9 d-flex align-items-center justify-content-end"
    }, [_c('div', [_c('div', {
      staticClass: "auto channel-change pull-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.edit_short_code(shortCode)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delete_short_code(shortCode.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.delete")))])])])])])])])])])])
  }), _vm._v(" "), (_vm.shortCodes.length > 0) ? _c('div', {
    staticClass: "list-group-item list-title"
  }, [_c('div', {
    staticClass: "list-mid-title-item"
  }, [_c('div', {
    staticClass: "list-title-item-div"
  }, [_c('div', {
    staticClass: "stick-top stick-small-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "square"
  })])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "new-custom-short-code-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editShortCode ? _vm.update_short_code() : _vm.save_short_code()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.editShortCode ? _vm.$t('automation.index.custom_short_codes.edit') :
    _vm.$t('automation.index.custom_short_codes.create')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#new-custom-short-code-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.custom_short_codes.name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": "Custom short code name"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShortCode.title),
      expression: "newShortCode.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Custom code name",
      "required": ""
    },
    domProps: {
      "value": (_vm.newShortCode.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newShortCode, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.custom_short_codes.content")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": "Replacable content"
    }
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newShortCode.content),
      expression: "newShortCode.content"
    }],
    ref: "newShortCodeContent",
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "6",
      "placeholder": "Write a message...",
      "required": ""
    },
    domProps: {
      "value": (_vm.newShortCode.content)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.focusElement('newShortCodeContent', _vm.newShortCode, 'content')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newShortCode, "content", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.notEmptyRentals) ? _c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "col-12 panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-5"
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.this_rental")))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": "Rental"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn mb-5 shortcodes",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openShortcodeListModal('#shortcode-list-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))])]), _vm._v(" "), _c('div', {
    staticClass: "rentals-list",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, _vm._l((_vm.shortCodeRentalGroups), function(group) {
    return (group.rentals.length > 0) ? _c('ul', {
      staticClass: "m-l-30 m-10",
      attrs: {
        "id": "short-code-list"
      }
    }, [_c('label', {
      attrs: {
        "for": group.name
      }
    }, [_vm._v(_vm._s(group.name === 'others' ? _vm.$t('groups.others') : group.name))]), _vm._v(" "), _vm._l((group.rentals), function(rental) {
      return _c('li', {
        staticClass: "m-l-10"
      }, [_c('div', {
        staticClass: "col-2"
      }, [_c('label', {
        attrs: {
          "for": rental.name
        }
      }, [_vm._v(_vm._s(rental.name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-1"
      }), _vm._v(" "), _c('div', {
        staticClass: "col-9"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (rental.short_code_text),
          expression: "rental.short_code_text"
        }],
        ref: ("rentalShortcode" + (rental.id)),
        refInFor: true,
        staticClass: "form-control",
        attrs: {
          "cols": "20",
          "rows": "4"
        },
        domProps: {
          "value": (rental.short_code_text)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.focusElement(("rentalShortcode" + (rental.id)), rental, 'short_code_text')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(rental, "short_code_text", $event.target.value)
          }
        }
      })])])])
    })], 2) : _vm._e()
  }))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.smallLoading) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "id": "modal-close",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#new-custom-short-code-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.smallLoading) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.editShortCode ? _vm.$t("button.update") :
    _vm.$t("button.save")))]) : _vm._e(), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1)])])])]), _vm._v(" "), _c('VShortCodeListModal', {
    attrs: {
      "selectedShortCode": _vm.selectedShortCode,
      "shortCodeName": _vm.shortCodeName,
      "fromCustomShortCode": true
    },
    on: {
      "insertShortcodeToText": _vm.insertShortcodeToCustomShortCodeText,
      "closeAndOpenModals": _vm.closeAndOpenModals,
      "changeSelectedShortCode": _vm.changeSelectedShortCode
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('VImportNotifications', {
    on: {
      "getAutoActions": _vm.get_autoactions
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd3d2a8"}!./src/app/pages/automation/index/index.html
// module id = 1327
// module chunks = 0